<template>

                                      <v-select
                                          v-model="filterValue"
                                          :items="filterOptions" clearable
                                          @change="handleInputChange"
                                          item-text="value"
                                          item-value="key"
                                          menu-props="bottom, offsetY"
                                          :label="st(config.label)"
                                    />
</template>
 
 <script> 

import BaseModule from '../../common/BaseModule.js'

 export default {
   name: 'SelectFilter',
   props: ['config','context'],
   mixins: [BaseModule],
   components: { 
   },
   data() {
       return {
           filterValue: null,
           lastEvent: null,
           filterOptions: [ ]
       }
   },
    mounted() {
        this.filterOptions = this.config.choices;
				this.filterOptions.forEach(f => f.value = this.st(f.value));
    },watch: {
       context: function() { 
				if (!this.context.filters || this.context.filters.length === 0) {
					this.filterValue = null;
          this.lastEvent = this.filterValue;
					return;
				}
				var filter = this.context.filters.find(f => f.type === 'select');
				if (filter) {
					this.filterValue = filter.value;
          this.lastEvent = this.filterValue;
				}
      },
     },
     destroyed() { 
    },
    methods: {
        getValue() {
            return this.filterValue;
        },
        handleInputChange() {
            this.$emit('change',this.filterValue);
        }
    }
 };
 </script>
  